<!--  -->

<div class="row mt-2">
  <div class="col-2 p-4">
    <p-dropdown [options]="stripeDurationOptions" [(ngModel)]="selectedStripeDuration"
      [showClear]="false" [placeholder]="'adminInsightsChart.selectSalesDuration' | transloco"
    (onChange)="onStripeDurationChange($event)"></p-dropdown>
  </div>
  <div class="col-10">
  </div>


</div>
<div class="p-3">
  <!-- <div class="chart-container"> -->
  @if (insightsStripeChartDataLoaded) {
    <div class="total-sales">
      <!-- {{totalValues}} -->
      @if (insightsSeriesData.SeriesName == 'Total Paid Invoice Amount') {
        {{insightsSeriesData.SeriesName}}: {{ calculateTotalSales()  | currency:'USD':'symbol':'1.2-2' }}
      }
      @if (insightsSeriesData.SeriesName == 'Total Paid Invoices') {
        {{insightsSeriesData.SeriesName}}: {{ calculateTotalSales() }}
      }
    </div>
  }
  <!-- Chart -->
  @if (insightsStripeChartDataLoaded) {
    <div>
      <p-chart id="{{selectedTabIndex}}" [type]="'line'" height="300px" [data]="insightsStripeChartData" [options]="insightsStripeChartOptions"></p-chart>
    </div>
  }
<!-- </div> -->
</div>